import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { ClareSystem, ClareSystemHelper, Project, SecuritySystem } from "@app/project/model";

interface UpdateProjectOutput {
    clareSystem: ClareSystem;
    securitySystem: SecuritySystem;
}

@Component({
    selector: "app-add-panel-info-step",
    templateUrl: "./add-panel-info-step.component.html",
    styleUrls: ["./add-panel-info-step.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddPanelInfoStepComponent {
    @Input() isReadOnly = false;
    @Input() existingProject: Project;
    @Output() updateProject: EventEmitter<UpdateProjectOutput> = new EventEmitter<UpdateProjectOutput>();

    public onControllerUpdate([clareSystemAction, securitySystemAction]) {
        let securitySystem = new SecuritySystem(null);
        let clareSystem = ClareSystemHelper.getDefault();

        if (securitySystemAction) {
            securitySystem = securitySystemAction.payload;
        }

        if (clareSystemAction) {
            clareSystem = clareSystemAction.claresystem;
            this.updateProject.emit({ clareSystem, securitySystem });
        }
    }
}
